import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import Link from './Link';

const Footer: FC = () => { 
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="body1"
            fontSize={12}
            color="textSecondary" display="flex" alignItems="center" justifyContent="space-between">
        <Typography color="textSecondary" variant="subtitle2" sx={{ fontSize: '12px' }}>
          {`© ${new Date().getFullYear()} My Airway Exam. All rights reserved.`} ❤️
        </Typography>
        <Link native href="/privacy_policy.html" underline="none" target='__blank'>Privacy Policy</Link>
        <Link native href="/terms_of_service.html" underline="none" target='__blank'>Terms of Service</Link>
        <Link to="mailto:hello@myairflowexam.com" underline="none">
          <Typography
            sx={{ textDecoration: 'none' }}
            display="flex"
            alignItems="center"
            fontSize="inherit"
          >
            <Icon icon="ic:outline-email" />
            &nbsp;Contact
          </Typography>
        </Link>
      </Typography>
    </Paper>
  );
};

export default Footer;
